import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import PartnerTooltip from "../components/PartnerTooltip";
import PartnerServices from "../../based/services/PartnerServices";
import Common from "../../based/Common";

const TAB_PARTNER = {
    PARTNER: 1,
    RANUS: 0,
    COLLAB: 3,
};

const PartnerGiftCollab = ({campaign, setIsShowModalGiftShow, setIsShowModalGift, isShowModalGift }) => {
    const history = useHistory();
    const [tab, setTab] = useState(TAB_PARTNER.PARTNER);
    const [partnerCollab, setPartnerCollab] = useState({});
    const [gifts, setGifts] = useState([]);


    useEffect(()=>{
        if (campaign && campaign.id) {
            getPartnerCollab(campaign.id);
            getGiftInCamPaign(campaign.id, TAB_PARTNER.PARTNER);
        }else{
            setGifts([])
            setPartnerCollab({})
        }
    },[campaign])

 
    useEffect(() => {
        if (!isShowModalGift.isShow && tab == TAB_PARTNER.COLLAB){
            getGiftCollabInCamPaign(campaign.id, partnerCollab.id);
        } 
    }, [isShowModalGift]);

    
    const getPartnerCollab = async (campaignId) => {
        let [err, data] = await PartnerServices.GetPartnerCollabByCampaign(campaignId);
        if (!err && data && data.length > 0) {
            setPartnerCollab(data[0]);
        } else {
            setPartnerCollab({});
        }
    };

    const getGiftInCamPaign = async (id, type) => {
        let [err, data] = await PartnerServices.GetGiftByCampaignId(id, type);
        if (!err && data && data.length > 0) {
            setGifts(data);
        } else {
            setGifts([]);
        }
    };

    const getGiftCollabInCamPaign = async (campaignId, collabId) => {
        let [err, data] = await PartnerServices.GetGiftCollabByCampaignId(campaignId, collabId);
        if (!err && data && data.length > 0) {
            setGifts(data);
        } else {
            setGifts([]);
        }
    };

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    }, []);

    return (
        <PartnerGiftCollabStyle className="partner-home-body">
            <div className="body-container">
                <div className="gift-container">
                    <div className="gift-tab">
                        <div
                            style={{ width: "33.33333%"}}
                            className={`gift-tab-item ${tab === TAB_PARTNER.PARTNER ? "active" : ""}`}
                            onClick={() => {
                                setTab(TAB_PARTNER.PARTNER);
                                getGiftInCamPaign(campaign.id, TAB_PARTNER.PARTNER);
                            }}
                        >
                            {campaign.brandName}
                        </div>
                        {partnerCollab && partnerCollab.id && (
                            <div
                                style={{ width: "33.33333%" }}
                                className={`gift-tab-item ${tab === TAB_PARTNER.COLLAB ? "active" : ""}`}
                                onClick={() => {
                                    setTab(TAB_PARTNER.COLLAB);
                                    getGiftCollabInCamPaign(campaign.id, partnerCollab.id)
                                }}
                            >
                                {partnerCollab.brandName}
                            </div>
                        )}

                        <div
                            style={{ width: "33.33333%" }}
                            className={`gift-tab-item ${tab === TAB_PARTNER.RANUS ? "active" : ""}`}
                            onClick={() => {
                                setTab(TAB_PARTNER.RANUS);
                                getGiftInCamPaign(campaign.id, TAB_PARTNER.RANUS);
                            }}
                        >
                            Ranus
                        </div>
                    </div>
                    <div className="gift-date" style={{ borderRadius: tab === TAB_PARTNER.PARTNER ? "0 10px 0 0" : "10px 0 0 0" }}>
                        {campaign && campaign.startDate && campaign.endDate
                            ? `Chương trình bắt đầu từ ${Common.formatDate(new Date(campaign.startDate), "month")} đến ${Common.formatDate(new Date(campaign.endDate), "month")}`
                            : "Chưa có chiến dịch nào"}
                    </div>
                    <div className="box-gift-table">
                        <table className="gift-table">
                            <tr className="gift-table-header">
                                <th>Giải thưởng</th>
                                <th style={{ width: 100 }}>Tổng phần quà</th>
                            </tr>
                            {gifts.length > 0 &&
                                gifts.map((item, idx) => {
                                    return (
                                        <tr
                                            key={idx}
                                            className={`gift-table-body`}
                                            onClick={() => {
                                                if (tab === TAB_PARTNER.RANUS || tab === TAB_PARTNER.PARTNER)
                                                    setIsShowModalGiftShow({
                                                        isShow: true,
                                                        giftItem: item,
                                                    });
                                                else
                                                    setIsShowModalGift({
                                                        isShow: true,
                                                        giftItem: item,
                                                    });
                                            }}
                                        >
                                            <td style={{ textAlign: "left" }}>{item.name}</td>
                                            <td>{item.countTotalAllCampaign}</td>
                                        </tr>
                                    );
                                })}
                        </table>
                    </div>
                </div>
                <div className="gift-remind">Chiến dịch được Ranus tạo</div>
                {campaign && campaign.id > 0 && tab === TAB_PARTNER.COLLAB && (
                    <div
                        className="gift-add"
                        onClick={() => {
                            setIsShowModalGift({
                                isShow: true,
                                giftItem: {
                                    name: "",
                                    id: 0,
                                    marketingCampaignId: campaign.id,
                                    giftType: 3,
                                    partnerCollabId: campaign.partnerCollabId,
                                },
                            });
                        }}
                    >
                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="24" cy="24" r="24" fill="#B3282D" />
                            <path d="M24 15V33" stroke="white" strokeWidth="3" strokeLinecap="round" />
                            <path d="M33 24L15 24" stroke="white" strokeWidth="3" strokeLinecap="round" />
                        </svg>
                    </div>
                )}
            </div>
        </PartnerGiftCollabStyle>
    );
};
const PartnerGiftCollabStyle = styled.div`
    @media (min-width: 768px) {
        .gift-add {
            display: none;
        }
        .gift-pin {
            .button-add-gift {
                display: block !important;
            }
        }
    }

    .gift-remind {
        color: #000;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 1;
        margin-top: 100px;
    }

    .gift-pin {
        display: flex;
        justify-content: space-between;

        .gift-pin-left {
            display: flex;
            align-items: center;

            .button-detail {
                position: relative;

                :hover {
                    .customise-tooltip {
                        display: block;
                    }
                }
            }

            span {
                margin-left: 10px;
                display: block;
            }
        }
        .gift-pin-box {
            border-radius: 10px;
            border: 1px solid #e1e1e1;
            background: #fff;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 210px;
            padding: 0 12px;

            strong {
                color: #505050;
                font-family: Lexend;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
            }

            div {
                display: flex;
            }
            span {
                color: #b9b9b9;
                font-family: Lexend;
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                display: block;
                margin-left: 10px;
            }
        }
        .button-add-gift {
            display: none;
            border-radius: 12px;
            background: #b3282d;
            border: none;
            outline: none;
            height: 36px;
            padding: 0 10px;
            color: #fff;
            text-align: center;
            font-family: Lexend;
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 36px;
        }
    }

    .gift-container {
        margin-top: 20px;
        .gift-tab {
            display: flex;

            .gift-tab-item {
                color: #444;
                font-family: Lexend;
                font-size: 16px;
                font-style: normal;
                font-weight: 600;
                line-height: 44px;
                text-align: center;
                border-radius: 10px 10px 0px 0px;
                height: 44px;

                &.active {
                    color: #b3282d;
                    background: #fff;
                }
            }
        }

        .gift-date {
            text-align: center;
            height: 34px;
            background: #ffd3d5;
            color: #b3282d;
            font-family: Lexend;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 34px;
        }

        .box-gift-table {
            background-color: #ffffff;
            padding: 12px 12px 60px 12px;
            border-radius: 0 0 10px 10px;

            .gift-table {
                border-radius: 10px;
                overflow: hidden;
                width: 100%;

                .gift-table-header {
                    th,
                    td {
                        border: 1px solid #e1e1e1;
                        background: #7a7a7a;
                        color: #fff;
                        text-align: center;
                        font-family: Lexend;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: normal;
                        padding: 8px 0;
                    }
                }
                .gift-table-body {
                    th,
                    td {
                        border: 1px solid #e1e1e1;
                        background: #fff;
                        color: #505050;
                        font-family: Lexend;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                        text-align: center;
                        padding: 10px;
                    }

                    &.row-even {
                        th,
                        td {
                            background-color: #ededed;
                        }
                    }

                    &.row-error {
                        th,
                        td {
                            background-color: #ffbdbd;
                            color: #ce0000;
                        }
                    }
                }
            }
        }
    }

    .gift-add {
        position: fixed;
        left: 12px;
        bottom: 72px;
    }
`;
export default PartnerGiftCollab;
